import React from "react";
import { AlertTriangle } from "lucide-react";

export default function ErrorBox({ message }) {
    return (
        <div className="mb-4 flex items-start gap-2 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            <AlertTriangle size={18} className="mt-0.5" />
            <span>{message}</span>
        </div>
    );
}
